import {ModuleComponent} from "../../js/module-component";

/**
 * Hero "Donde todo conecta" (SEION) — grafo con ciclo de 3 fases.
 *  - Ciclo integra → aplica IA → optimiza: cambia píldora activa, subtítulo del
 *    hub, opacidad de pulsos entrantes/salientes, anillos de IA, chips y evento.
 *  - Prueba social rotativa + parallax de puntero.
 *  Textos traducidos desde el Twig (JSON). Respeta prefers-reduced-motion.
 */
export class ModAgentsThree extends ModuleComponent{

    ready(){
        super.ready();

        this.el = this.$root.get(0);
        if(!this.el) return;

        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.phaseMs = 3400;
        this.proofMs = 3700;

        // Contenido por defecto (fallback). Se sobreescribe con el JSON del Twig.
        this.phases = [
            {title: "Fase 1 · Integrando", sub: "Integration Hub", events: [
                ["Conectando ", "ERP y CRM", " → catálogo, clientes y pedidos sincronizados"],
                ["E-commerce y pagos vinculados → ", "stock", " actualizado en tiempo real"]
            ]},
            {title: "Fase 2 · Aplicando IA", sub: "Capa de IA", events: [
                ["Datos centralizados → los ", "agentes de IA", " ya consultan una sola fuente"],
                ["La IA detecta patrones y propone ", "automatizaciones", " por proceso"]
            ]},
            {title: "Fase 3 · Optimizando", sub: "Procesos automáticos", events: [
                ["Pedido creado → confirmación por ", "WhatsApp", " y tarea comercial asignada"],
                ["Incidencia entrante → ticket ", "clasificado", " y resuelto sin gestión manual"]
            ]}
        ];
        this.proofs = [];

        const dataEl = this.el.querySelector(".js-agents-three-data");
        if(dataEl){
            try {
                const parsed = JSON.parse(dataEl.textContent);
                if(parsed && Array.isArray(parsed.phases) && parsed.phases.length) this.phases = parsed.phases;
                if(parsed && Array.isArray(parsed.proofs)) this.proofs = parsed.proofs;
            } catch(e){ /* fallback */ }
        }

        // Referencias
        this.pills      = Array.from(this.el.querySelectorAll(".js-phases .web-mod-agents-three__pill"));
        this.hubSub     = this.el.querySelector(".js-hub-sub");
        this.eventTitle = this.el.querySelector(".js-event-title");
        this.eventBody  = this.el.querySelector(".js-event-body");
        this.inbound    = this.el.querySelector(".js-inbound");
        this.outbound   = this.el.querySelector(".js-outbound");
        this.aiRing     = this.el.querySelector(".js-ai-ring");
        this.results    = this.el.querySelector(".js-results");
        this.network    = this.el.querySelector(".js-network");

        this.phase = 0;
        this.step = 0;
        this.timers = [];

        this.startProofRotation();
        this.startPhaseCycle();
        this.startParallax();
    }

    // -- Estado por fase -----------------------------------------------------
    applyPhase(){
        const p = this.phase;
        this.pills.forEach((el, i) => el.classList.toggle("is-active", i === p));
        if(this.hubSub) this.hubSub.textContent = this.phases[p].sub;
        if(this.inbound)  this.inbound.style.opacity  = (p === 2) ? "0.12" : "1";
        if(this.outbound) this.outbound.style.opacity = (p === 2) ? "1" : "0";
        if(this.aiRing)   this.aiRing.style.opacity   = (p === 1) ? "1" : "0";
        if(this.results){
            this.results.style.opacity = (p === 2) ? "1" : "0";
            this.results.style.transform = (p === 2) ? "none" : "translateY(10px)";
        }
    }

    applyEvent(){
        const ph = this.phases[this.phase];
        if(this.eventTitle) this.eventTitle.textContent = ph.title;
        const ev = ph.events[Math.min(this.step, ph.events.length - 1)] || ["", "", ""];
        if(this.eventBody){
            this.eventBody.textContent = "";
            this.eventBody.appendChild(document.createTextNode(ev[0] || ""));
            const strong = document.createElement("strong");
            strong.textContent = ev[1] || "";
            this.eventBody.appendChild(strong);
            this.eventBody.appendChild(document.createTextNode(ev[2] || ""));
        }
    }

    // -- Rotación de la prueba social ----------------------------------------
    startProofRotation(){
        if(this.reduceMotion) return;
        const proofEl = this.el.querySelector(".js-proof-text");
        const container = this.el.querySelector(".web-mod-agents-three__proof");
        if(!proofEl || !container) return;
        const items = (container.dataset.proofs || "").split("|").filter(Boolean);
        if(items.length < 2) return;
        let i = 0;
        const timer = setInterval(() => {
            proofEl.classList.add("is-fading");
            setTimeout(() => {
                i = (i + 1) % items.length;
                proofEl.textContent = items[i];
                proofEl.classList.remove("is-fading");
            }, 280);
        }, this.proofMs);
        this.timers.push(timer);
    }

    // -- Ciclo de fases (integra → IA → optimiza) ----------------------------
    startPhaseCycle(){
        if(this.reduceMotion) return;
        const timer = setInterval(() => {
            if(this.eventBody) this.eventBody.classList.add("is-fading");
            if(this.hubSub) this.hubSub.classList.add("is-fading");
            setTimeout(() => {
                const step = this.step + 1;
                const phaseLen = this.phases[this.phase].events.length;
                let phaseChanged = false;
                if(step < phaseLen){
                    this.step = step;
                }else{
                    this.phase = (this.phase + 1) % this.phases.length;
                    this.step = 0;
                    phaseChanged = true;
                }
                if(phaseChanged) this.applyPhase();
                this.applyEvent();
                if(this.eventBody) this.eventBody.classList.remove("is-fading");
                if(this.hubSub) this.hubSub.classList.remove("is-fading");
            }, 300);
        }, Math.max(1600, this.phaseMs));
        this.timers.push(timer);
    }

    // -- Parallax de puntero (escritorio) ------------------------------------
    startParallax(){
        if(this.reduceMotion || !this.network) return;
        const layers = Array.from(this.network.querySelectorAll("[data-parallax]"));
        this.onMove = (e) => {
            if(window.innerWidth < 800) return;
            const r = this.network.getBoundingClientRect();
            const x = (e.clientX - r.left) / r.width - .5;
            const y = (e.clientY - r.top) / r.height - .5;
            layers.forEach(el => {
                const p = Number(el.dataset.parallax || .2);
                el.style.setProperty("--px", (x * 18 * p).toFixed(2) + "px");
                el.style.setProperty("--py", (y * 18 * p).toFixed(2) + "px");
            });
        };
        this.onLeave = () => layers.forEach(el => { el.style.removeProperty("--px"); el.style.removeProperty("--py"); });
        this.network.addEventListener("pointermove", this.onMove, {passive: true});
        this.network.addEventListener("pointerleave", this.onLeave, {passive: true});
    }

    destroy(){
        this.timers.forEach(t => clearInterval(t));
        if(this.network){
            this.network.removeEventListener("pointermove", this.onMove);
            this.network.removeEventListener("pointerleave", this.onLeave);
        }
        if(super.destroy) super.destroy();
    }
}
